import { createContext, FC, useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  deleteUsersInSuscription,
  getUserById,
  getUsersInSuscription,
} from "../../api/broker";
import { iDataUser } from "../../interfaces/SuperAdmin/Pages/iDataUser";
import { iDataUserSuscription } from "../../interfaces/SuperAdmin/Pages/iDataUserSuscription";

interface UserSuscriptionContextProps {
  user: iDataUser;
  suscriptions: iDataUserSuscription[];
  toDeleteSuscr: string;
  isLoading: boolean;
  isDeleting: boolean;
  assignToDeleteSuscr: (suscrId: string) => void;
  handleDelete: () => Promise<void>;
}

const UserSuscriptionContext = createContext<UserSuscriptionContextProps>(
  {} as UserSuscriptionContextProps
);

interface Props {
  children: React.ReactNode;
}

const UserSuscriptionProvider: FC<Props> = ({ children }) => {
  const { idUser } = useParams();
  const [user, setUser] = useState<iDataUser>({} as iDataUser);
  const [suscriptions, setSuscriptions] = useState<iDataUserSuscription[]>([]);
  const [toDeleteSuscr, setToDeleteSuscr] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  //Fetch del usuario y sus suscripciones
  useEffect(() => {
    const fetchAll = async () => {
      if (idUser) {
        setIsLoading(true);
        try {
          //Fetch del plan y todas las suscripciones
          const [userRes, susRes] = await Promise.all([
            getUserById(idUser),
            getUsersInSuscription(undefined, idUser),
          ]);
          console.log(userRes);
          console.log(susRes);
          if (
            userRes.data.statusCode === 200 &&
            susRes.data.statusCode === 200
          ) {
            setUser(userRes.data.body); // Asignamos el usuario
            setSuscriptions(susRes.data.body); //Asignamos las suscripciones
          } else {
            toast.error("Error al obtener el usuario y/o sus suscripciones");
          }
        } catch (error) {
          console.log(error);
          toast.error("Error al obtener el usuario y/o sus suscripciones");
        } finally {
          setIsLoading(false);
        }
      }
    };
    fetchAll();
  }, [idUser]);

  const assignToDeleteSuscr = (suscrId: string) => {
    setToDeleteSuscr(suscrId);
  };

  const handleDelete = async () => {
    if (toDeleteSuscr && idUser) {
      setIsDeleting(true);
      try {
        const res = await deleteUsersInSuscription({
          id_usuarios: [idUser],
          id_suscripcion: toDeleteSuscr,
        });
        console.log(res);

        if (res.data.statusCode === 200) {
          setSuscriptions((prev) => {
            const filteredSuscr = prev.filter(
              (suscr) => suscr.id_suscripcion !== toDeleteSuscr
            );
            return filteredSuscr;
          });
          setToDeleteSuscr("");
          toast.success("Usuario eliminado de la suscripción exitosamente");
        } else {
          toast.error("Error al eliminar usuario de la suscripción ");
        }
      } catch (error) {
        console.log(error);
        toast.error("Error al eliminar usuario de la suscripción ");
      } finally {
        setIsDeleting(false);
      }
    }
  };

  return (
    <UserSuscriptionContext.Provider
      value={{
        user,
        suscriptions,
        toDeleteSuscr,
        isLoading,
        isDeleting,
        assignToDeleteSuscr,
        handleDelete,
      }}
    >
      {children}
    </UserSuscriptionContext.Provider>
  );
};

const useSuperAdminUserSuscription = () => useContext(UserSuscriptionContext);

export { UserSuscriptionProvider, useSuperAdminUserSuscription };
